<script setup>
// Generic below-the-fold gate: the default slot's component is never
// imported/mounted until this wrapper's own placeholder scrolls near the
// viewport. Used for homepage sections that have no SSR-valuable content
// today (they already rendered nothing server-side behind <ClientOnly>),
// so gating them this way removes their JS from the initial bundle/graph
// with zero SEO/content loss versus the previous behavior.
const props = defineProps({
  rootMargin: { default: '200px 0px', type: String },
})

const rootEl = ref(null)
const visible = ref(false)
let observer

onMounted(() => {
  if (typeof IntersectionObserver === 'undefined') {
    visible.value = true
    return
  }
  observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      visible.value = true
      observer.disconnect()
    }
  }, { rootMargin: props.rootMargin })
  observer.observe(rootEl.value)
})

onBeforeUnmount(() => observer?.disconnect())
</script>

<template>
  <div ref="rootEl">
    <slot v-if="visible" />
    <!-- Server-rendered stand-in (e.g. plain links for crawlers) until the
         real section mounts. -->
    <slot v-else name="fallback" />
  </div>
</template>
